import { render, staticRenderFns } from "./header-haga-norra.vue?vue&type=template&id=01c90d18&scoped=true"
import script from "./header-haga-norra.vue?vue&type=script&lang=js"
export * from "./header-haga-norra.vue?vue&type=script&lang=js"
import style0 from "./header-haga-norra.vue?vue&type=style&index=0&id=01c90d18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c90d18",
  null
  
)

export default component.exports